module.exports = "/_next/static/images/recommend-product-ded6dc32643a727ac0f52b28d589bc50.png";